import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { getPasswordResetEmail } from "seneca-common/features/user/state";
import { useRedirectOnCondition } from "seneca-common/utils/hooks/routing";

import ResetPasswordSignInForm from "features/sign-up/password-reset-form/containers/ResetPasswordSignInForm";

type Props = {
  pageNumber?: number;
  totalNumberOfPages?: number;
  linkToPasswordReset: string;
  redirectAuthenticatedUserTo?: string;
  redirectOnSignInCallback?: () => void;
};

export default function ResetPasswordSignIn({
  redirectAuthenticatedUserTo,
  linkToPasswordReset,
  pageNumber,
  totalNumberOfPages,
  redirectOnSignInCallback
}: Props) {
  const history = useHistory();

  useRedirectOnCondition(
    !useSelector(getPasswordResetEmail),
    linkToPasswordReset
  );

  function onSignInSuccess() {
    history.push(redirectAuthenticatedUserTo || "/");
  }

  return (
    <ResetPasswordSignInForm
      pageNumber={pageNumber}
      totalNumberOfPages={totalNumberOfPages}
      onSignInSuccess={redirectOnSignInCallback ?? onSignInSuccess}
    />
  );
}
